import axios from 'axios'
import router from '../router/index.js'
// 创建axios实例
const service = axios.create({
  //baseURL: 'http://srm.xmstm.com.cn/', // api的base_url
  baseURL: 'http://kejiguan.huudon.cn/', // 测试
  // baseURL: 'http://srm.xmstm.com.cn/', //生产
  timeout: 5000 // 请求超时时间
})
// 请求拦截器
service.interceptors.request.use(config => {
  config.headers.common['token'] = `${localStorage.getItem('token')}`;
  return config;
}, error => {
  return Promise.reject(error);
});
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 请求成功的处理
    // 可以对响应数据 response 进行操作
    if (response.data.code === 1 || response.data.code === 0) {
      return response;
    } else if (response.data.code === -1) {
      localStorage.removeItem('userInfo')
      router.push('/')
    }

  },
  error => {
    console.log(error, 100000)
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/request.js